import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import JDIPrice from "@/common-components-src/js/price/index";
import UKImg from "@/common-components-src/components/UKImg";
import styles from "./index.module.scss";
import { SkuListVo } from "@/app/csr-src/apis/afterSales/afterSales.interface";

// 组件
import ProductTag from "@/app/csr-src/pages/order/components/productTag";
// untis
import { jumpToDp } from "@/app/csr-src/pages/order/utils/jumpMethod";

interface detailProductProps {
  wareInfoDTOList: SkuListVo[];
}

const detailProduct: React.FC<detailProductProps> = observer(({ wareInfoDTOList }) => {
  const { t } = useTranslation();

  // 跳转商详
  const jumpProductDetail = (item: SkuListVo) => {
    jumpToDp(String(item?.skuId) || "", item?.jumpParam);
  };

  if (!wareInfoDTOList?.length) {
    return null;
  }

  // 计算Order items
  const calcNum = (list: SkuListVo[]) => {
    return list.reduce((sum: number, item) => sum + Number(item.appliedCount), 0);
  };

  return (
    <div className={styles.wrap}>
      <div className={styles.product_title}>
        {t("afterSales.detailProduct.returnItemsText")}
        {wareInfoDTOList?.length ? `(${calcNum(wareInfoDTOList)})` : null}
      </div>
      <ul className={styles.product_outer_wrap}>
        {wareInfoDTOList?.length
          ? wareInfoDTOList.map((item, index) => {
              const showOriginPrice = item.skuPrice && Number(item.skuPrice) > Number(item.skuSingleShouldPrice);
              return (
                <li key={index} className={styles.product_wrap} onClick={() => jumpProductDetail(item)}>
                  <div className={styles.left_product}>
                    <div className={styles.product_info}>
                      <div className={styles.product_img}>
                        <UKImg
                          urlExtend={{
                            imgKey: item.skuImg ? item.skuImg : "",
                            width: 120,
                            height: 120,
                          }}
                        />
                      </div>
                      <div className={styles.product_main_info}>
                        <div className={styles.product_name}>
                          <div className={styles.tagsWrap}>
                            <ProductTag tagList={item?.showTagList || []} />
                          </div>
                          <span className={styles.product_name_cont}>{item.skuName}</span>
                        </div>
                        <div className={styles.product_desc}>{item.propertyExt}</div>
                      </div>
                    </div>
                  </div>
                  <div className={styles.right_product}>
                    <div className={styles.price_wrap}>
                      {/* 到手价 */}
                      <div className={styles.real_price}>
                        <JDIPrice
                          symbol={item.feeCurrencySymbol || ""}
                          price={item.skuSingleShouldPrice || ""}
                          uiType={1}
                          containerStyle={{
                            fontSize: "12px",
                            lineHeight: "16px",
                          }}
                          integerStyle={{
                            fontSize: "18px",
                            lineHeight: "24px",
                            height: "24px",
                          }}
                        />
                      </div>
                      {/* 划线价 */}
                      {/* 划线价与京东价一致则不展示 */}
                      {showOriginPrice ? (
                        <div className={styles.origin_price}>
                          <JDIPrice
                            symbol={item.feeCurrencySymbol || ""}
                            price={item.skuPrice || ""}
                            uiType={2}
                            containerStyle={{
                              fontSize: "12px",
                              lineHeight: "16px",
                            }}
                            lineThrough
                          />
                        </div>
                      ) : null}
                    </div>
                    <div className={styles.product_num}>×{item.appliedCount}</div>
                  </div>
                </li>
              );
            })
          : null}
      </ul>
    </div>
  );
});

export default detailProduct;
